<div class="tw-bg-white">
  <div class="tw-app-container tw-flex tw-justify-between tw-px-[16px] tw-py-[8px] tw-text-[#333333] tw-overflow-hidden">
    <div class="tw-flex-1 tw-flex tw-items-center tw-gap-[50px] xs:tw-gap-2">
      <div navigateLink="/" class="tw-cursor-pointer tw-flex-shrink-0">
        <img
          class="tw-object-contain tw-select-none tw-pointer-events-none xs:tw-h-[50px] tw-h-[84px]"
          src="/assets/images/logo_main.svg"
          alt="dealers stock"
        />
      </div>
      @if (this.currentUser()) {
        <app-search-input
          [control]="keywordControl"
          [searchProvider]="searchProvider"
          class="tw-flex-1 tw-max-w-[400px] gt-sm:tw-hidden tw-h-[36px]"
        />
      }
    </div>
    <div class="tw-hidden gt-sm:tw-flex tw-gap-4">
      @if (this.currentUser()) {
        <!-- ログイン済み -->
        @for (menuItem of navigationMenuItems; track menuItem.route) {
          <app-button [navigateLink]="menuItem.route" class="tw-my-auto">
            <div class="tw-flex tw-items-center tw-gap-2">
              <app-svg-icon [src]="menuItem.icon" class="tw-w-[1.25rem] tw-aspect-square" />
              <span class="tw-whitespace-nowrap">{{ menuItem.label }}</span>
            </div>
          </app-button>
        }
        <div class="tw-flex tw-items-center">
          <a [href]="guideLinks.loggedIn.url" class="tw-h-fit" appFlatButton flatButtonStyle="border-secondary">
            <app-svg-icon [src]="guideLinks.loggedIn.icon" class="tw-w-[1.5rem] tw-aspect-square" />
            <span>{{ guideLinks.loggedIn.label }}</span>
          </a>
        </div>
      } @else {
        <!-- 未ログイン -->
        <div class="tw-flex tw-items-center">
          <a [href]="guideLinks.loggedOut.url" class="tw-h-fit" appFlatButton flatButtonStyle="border-secondary">
            <app-svg-icon [src]="guideLinks.loggedOut.icon" class="tw-w-[1.5rem] tw-aspect-square" />
            <span>{{ guideLinks.loggedOut.label }}</span>
          </a>
        </div>
        <div class="tw-flex tw-items-center">
          <button (click)="navigateToLoginPage()" class="tw-h-fit" appFlatButton flatButtonStyle="secondary">
            <span>ログイン</span>
          </button>
        </div>
      }
    </div>
    <div class="tw-flex gt-sm:tw-hidden">
      <button type="button" class="" (click)="openMobileNav()" mat-ripple>
        <app-svg-icon src="/assets/icons/hamburger.svg" class="tw-w-[3rem] tw-my-auto tw-aspect-square" />
      </button>
    </div>
  </div>
</div>

<!-- モバイル用メニュー -->
<nav
  class="tw-absolute tw-top-0 tw-z-[1002] tw-w-full tw-translate-y-[-100%] tw-bg-[#101645] tw-py-[16px] tw-text-[16px] tw-text-white tw-opacity-0 tw-transition-transform xs:tw-block"
  [class.mobile-nav-opened]="this.isMobileNavigationOpened()"
>
  <div class="tw-absolute tw-right-[16px] tw-z-[1001]">
    <button type="button" class="tw-block tw-aspect-square tw-h-[42px] tw-p-[8px]" (click)="closeMobileNav()" mat-ripple>
      <app-svg-icon class="tw-text-white tw-aspect-square" src="/assets/images/cross.svg" />
    </button>
  </div>

  <ul class="tw-mb-[24px] tw-px-[16px]">
    @if (this.currentUser()) {
      <!-- ログイン済み -->
      @for (menuItem of mobileMenuItems; track menuItem.route) {
        <li>
          <button
            [navigateLink]="menuItem.route"
            type="button"
            mat-ripple
            class="tw-w-full tw-flex-wrap tw-py-[16px] tw-text-left tw-flex tw-items-center tw-gap-2"
            (click)="closeMobileNav()"
          >
            <app-svg-icon class="tw-h-5 tw-aspect-square" [src]="menuItem.icon" />
            <span>{{ menuItem.label }}</span>
          </button>
        </li>
      }
      <li>
        <a
          [href]="guideLinks.loggedIn.url"
          mat-ripple
          class="tw-w-full tw-flex-wrap tw-py-[16px] tw-text-left tw-flex tw-items-center tw-gap-2"
        >
          <app-svg-icon class="tw-h-6 tw-text-white tw-aspect-square" [src]="guideLinks.loggedIn.icon" />
          <span>{{ guideLinks.loggedIn.label }}</span>
        </a>
      </li>
    } @else {
      <!-- 未ログイン -->
      <li>
        <a
          [href]="guideLinks.loggedOut.url"
          mat-ripple
          class="tw-w-full tw-flex-wrap tw-py-[16px] tw-text-left tw-flex tw-items-center tw-gap-2"
        >
          <app-svg-icon class="tw-h-6 tw-text-white tw-aspect-square" [src]="guideLinks.loggedOut.icon" />
          <span>{{ guideLinks.loggedOut.label }}</span>
        </a>
      </li>
      <li>
        <button
          (click)="navigateToLoginPage()"
          type="button"
          mat-ripple
          class="tw-w-full tw-flex-wrap tw-py-[16px] tw-text-left tw-flex tw-items-center tw-gap-2"
        >
          <app-svg-icon src="/assets/icons/circle-user-solid.svg" class="tw-h-5 tw-aspect-square" />
          <span>ログイン</span>
        </button>
      </li>
    }
  </ul>
</nav>
